module.exports = __webpack_public_path__ + "static/media/phone-profile.41d1c3ac.svg";